import React, {Component} from 'react';
import {BrowserRouter, Route, Router, Switch} from 'react-router-dom';
import './App.scss';
import './index.css';
import Delay from "./components/Spinner/Delay/Delay";
import JWT_Decode from "jwt-decode";
import Cookies from 'js-cookie'
import * as actionCreator from "./store/Action";
import {connect} from "react-redux";
import axios from "axios";
import Login from "./views/Login/Login"
import ThankYouLayout from './containers/PublicPages/ThankYou/ThankYou';
import WebSignInLayout from './containers/PublicPages/WebSignUp/WebSignIn';
import WebSignUpLayout from './containers/PublicPages/WebSignUp/WebSignUp';
import GuestLogin from './views/Guest/Login/Login';
import ReceptionLayout from './containers/Reception'
import GuestLayout from './containers/GuestLayout'
import NotificationLayout from './containers/NotificationLayout'
import ExternalReceptionLayout from './containers/ExternalReception'
import SuperLayout from './containers/Super'
import CorporateLayout from './containers/Corporate'
import ParkTagLayout from './containers/ParkTag'
import VisitorRegistrationForm from './containers/VisitorRegistrationForm'
import VisitorForwardForm from './containers/VisitorForwardForm/VisitorForwardForm'
import HostLogin from './views/Host/Login/Login';
import VisitorChangeVehicleNumber from './containers/VisitorChangeVehicleNumber/VisitorChangeVehicleNumber';
import PublicUserDetailsLayout from './views/public/update-details/UpdateUser';

import EventTagLayout from './containers/EventTag'
import HostLayout from './containers/Host'
import OrganizerLayout from './containers/EventOrganizer'
import HRLayout from './containers/HRLayout';
import EventQuestionBankScreen from './containers/EventQuestionScreen/Layout';
import SpaceTagLayout from "./containers/SpaceTag/SpaceTagLayout";
import EventAppRedirectionLayout from "./containers/EventTag/EventAppRedirection";
import EventAppDownloadLayout from "./containers/EventTag/EventAppDownload";

import ParkAppRedirectionLayout from "./containers/ParkTag/ParkAppRedirection";
import ParkAppDownloadLayout from "./containers/ParkTag/ParkAppDownload";

import MdQrViewRedirection from "./containers/EventTag/MdQrRedirection";
import MdQrView from "./containers/EventTag/MdQrView";

import * as routeConstants from './const/route/Route';
import GuestRegister from "./views/Guest/Login/Register/Register";
import PublicCorporateRegistration from './containers/PublicCorporateRegistrationForm/PublicCorporateRegistrationForm'
import * as keys from "./const/key/Key";

class App extends Component {

  checkActiveSession = () => {
    this.props.browserHistoryHandler(this.props.history);
    let token = Cookies.get("68a6102f6ed24899420170004a0273b8");
    let user_obj_host = Cookies.get("3c8bed3b2d6ba6d3076ee8d2f588a4dx");

    if (window.location.pathname.indexOf("/visitor/registration/1U1oSo1VcV3ZubMsAZNXWtM6qJIEg-fSztJgrNrHFCl8") !== -1 ||
      window.location.pathname.indexOf("/visitor/forward/68d75609c6e9004cb5076ea7613b1d9b") !== -1 ||
      window.location.pathname.indexOf(routeConstants.QUESTION_BANK_ROUTE_PATH) !== -1 ||
      window.location.pathname.indexOf(routeConstants.PUBLIC_CORPORATE_SIGNUP) !== -1 ||
      window.location.pathname.indexOf(routeConstants.PUBLIC_THANK_YOU_PAGE) !== -1 ||
      window.location.pathname.indexOf(routeConstants.PUBLIC_WEB_SIGN_IN_PAGE) !== -1 ||
      window.location.pathname.indexOf(routeConstants.PUBLIC_WEB_SIGN_UP_PAGE) !== -1 ||
      window.location.pathname.indexOf(routeConstants.PUBLIC_WEB_USER_DETAILS) !== -1 ||
      window.location.pathname.indexOf(routeConstants.CHANGE_VEHICLE_NUMBER_ROUTE_PATH) !== -1 ||
      window.location.href.indexOf(routeConstants.GUEST_ROUTE_PATH) !== -1 ||
      window.location.href.indexOf(`${routeConstants.EVENT_APP_REDIRECTION_ROUTE_PATH}?e=`) !== -1 ||
      window.location.href.indexOf(`${routeConstants.PARK_APP_REDIRECTION_ROUTE_PATH}?e=`) !== -1 ||
      window.location.href.indexOf(`${routeConstants.EVENT_APP_DOWNLOAD_ROUTE_PATH}`) !== -1 ||
      window.location.href.indexOf(`${routeConstants.PARK_APP_DOWNLOAD_ROUTE_PATH}`) !== -1 ||
      window.location.href.indexOf(`${routeConstants.MD_QR_VIEW}`) !== -1
    ) {

      if (window.location.href.indexOf(routeConstants.GUEST_ROUTE_PATH) !== -1) {
        if (token !== undefined) {
          let decode_token = JWT_Decode(token);
          this.props.userHandler(decode_token.user);
        }
      }

    } else {
      if (token !== undefined) {
        axios.create().defaults.headers.common['Authorization'] = "Bearer " + token;

        let decode_token = JWT_Decode(token);
        this.props.userHandler(decode_token.user);
        let USER_ROLE = decode_token.user.userRoles;
        let USER_AUTHORITIES = decode_token.authorities[0];
        console.log("USER_ROLE",USER_ROLE)
        console.log("USER_AUTHORITIES",USER_AUTHORITIES)
        if (USER_ROLE === "RECEPTION") {
          if (window.location.pathname.indexOf("/reception") === -1) {
            this.props.history.push("/reception/dashboard");
          }

        } else if (USER_ROLE === "SYS_ADMIN") {
          if (window.location.pathname === "/" || window.location.pathname.indexOf("reception") !== -1) { //|| window.location.pathname.indexOf("corporate") !== -1 remove for sub routing
            this.props.history.push("/super/dashboard");
          }

          if (window.location.pathname === "/host" || window.location.pathname === "/host/login" || window.location.pathname === "/host/dashboard" || window.location.pathname === "/host/allMeetings") {
            this.props.history.push("/host/login");
          }

        } else if (USER_ROLE === "CORP_ADMIN") {
          let user_obj = Cookies.get("3c8bed3b2d6ba6d3076ee8d2f588a4dd");
          if (user_obj !== undefined) { // because, new window will open in super admin portal
            this.props.userHandler(JSON.parse(user_obj));
            if (window.location.pathname.indexOf("/corporate") === -1) {
              this.props.history.push("/corporate/dashboard");
            }

          } else {
            this.props.history.push("/");
          }

        } else if (USER_ROLE === "EXTERNAL_RECEPTION") {
          if (window.location.pathname.indexOf("/external-reception") === -1) {
            this.props.history.push("/external-reception/dashboard");
          }

        } else if (USER_ROLE === "CORP_EVENT_ADMIN") {
          if (window.location.pathname.indexOf("/eventtags") === -1) {
            this.props.history.push("/eventtags/dashboard");
            // this.props.history.push("/spacetags/workspace");
          }

        } else if (USER_ROLE === "CORP_EVENT_ORGANIZER") {
          if (window.location.pathname.indexOf("/eventorganizer") === -1) {
            this.props.history.push("/eventorganizer/dashboard")
          }

        } else if (USER_ROLE === keys.HR_USER_ROLE) {
          if (window.location.pathname.indexOf(routeConstants.HR_ROUTE_PATH) === -1) {
            this.props.history.push(`${routeConstants.HR_ROUTE_PATH}/dashboard`)
          }

        } else if (USER_ROLE === undefined) {
          if ('ROLE_MOBILE_USER' === USER_AUTHORITIES) {
            let guestIsLogin = localStorage.getItem(keys.GUEST_CACHE);
            if (guestIsLogin) {
              this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/profile`);
              return;
            }

            if (user_obj_host !== undefined) {
              if (window.location.pathname.indexOf("/host") !== -1) {
                this.props.userHandler(JSON.parse(user_obj_host));
              } else {
                this.props.history.push("/");
              }
            }
          } else {
            // this.props.history.push("/host/login");
          }
        }

      } else if (window.location.pathname.indexOf("/host") !== -1) {
        this.props.history.push("/host/login");

      } else {
        this.props.history.push("/");
      }
    }
  };

  componentWillMount() {
    this.checkActiveSession();
  }

  render() {
    return (
      <BrowserRouter>
        <Delay/>
        <Router history={this.props.history}>
          <Switch>
            <Route exact path="/login" name="Login Page" component={Login}/>
            <Route exact path="/host/login" name="Login Page" component={HostLogin}/>

            <Route exact path={`${routeConstants.GUEST_ROUTE_PATH}/login`} name="Guest Login Page"
                   component={GuestLogin}/>
            <Route exact path={`${routeConstants.GUEST_ROUTE_PATH}/register`} name="Guest Registration"
                   component={GuestRegister}/>

            <Route path={`${routeConstants.NOTIFICATION_ROUTE_PATH}`} name="Notification Home" component={NotificationLayout}/>
            <Route path={`${routeConstants.GUEST_ROUTE_PATH}`} name="Guest Home" component={GuestLayout}/>
            <Route path={`${routeConstants.PUBLIC_CORPORATE_SIGNUP}`} name={"Corporate Registration"} component={PublicCorporateRegistration}/>
            <Route path={`${routeConstants.PUBLIC_THANK_YOU_PAGE}`} name={"Thank you"} component={ThankYouLayout}/>
            <Route path={`${routeConstants.PUBLIC_WEB_SIGN_UP_PAGE}`} name="Home" component={WebSignUpLayout}/>
            <Route path={`${routeConstants.PUBLIC_WEB_SIGN_IN_PAGE}`} name="Home" component={WebSignInLayout}/>
            <Route path={`${routeConstants.PUBLIC_WEB_USER_DETAILS}`} name="UserDetails" component={PublicUserDetailsLayout}/>
            {/* event app redirection */}
            <Route path={`${routeConstants.EVENT_APP_REDIRECTION_ROUTE_PATH}`} name="EventApp" component={EventAppRedirectionLayout}/>
            <Route path={`${routeConstants.EVENT_APP_DOWNLOAD_ROUTE_PATH}`} name="EventApp" component={EventAppDownloadLayout}/>
            {/* park app redirection */}
            <Route path={`${routeConstants.PARK_APP_REDIRECTION_ROUTE_PATH}`} name="ParkApp" component={ParkAppRedirectionLayout}/>
            <Route path={`${routeConstants.PARK_APP_DOWNLOAD_ROUTE_PATH}`} name="ParkApp" component={ParkAppDownloadLayout}/>

            <Route path={`${routeConstants.MD_QR_VIEW_R}`} name="EventApp" component={MdQrViewRedirection}/>
            <Route path={`${routeConstants.MD_QR_VIEW}`} name="EventApp" component={MdQrView}/>

            <Route path="/parktags" name="Home" component={ParkTagLayout}/>
            <Route path="/reception" name="Home" component={ReceptionLayout}/>
            <Route path="/external-reception" name="Home" component={ExternalReceptionLayout}/>
            <Route path="/corporate" name="Home" component={CorporateLayout}/>

            <Route path="/eventtags" name="Home" component={EventTagLayout}/>

            <Route path="/spacetags" name="Home" component={SpaceTagLayout}/>

            <Route path="/host" name="Home" component={HostLayout}/>
            <Route path="/eventorganizer" name="Home" component={OrganizerLayout}/>
            <Route path={`${routeConstants.HR_ROUTE_PATH}`} name="Home" component={HRLayout}/>

            <Route path="/super" name="Home" component={SuperLayout}/>
            <Route path="/visitor/registration/1U1oSo1VcV3ZubMsAZNXWtM6qJIEg-fSztJgrNrHFCl8"
                   name="Public Visitor Registraton" component={VisitorRegistrationForm}/>
            <Route path="/visitor/forward/68d75609c6e9004cb5076ea7613b1d9b" name="Visitor Forward"
                   component={VisitorForwardForm}/>

            <Route path={routeConstants.QUESTION_BANK_ROUTE_PATH} component={EventQuestionBankScreen}/>
            {/* change vehicle number*/}
            <Route path={routeConstants.CHANGE_VEHICLE_NUMBER_ROUTE_PATH} component={VisitorChangeVehicleNumber}/>



            <Route exact path="/" name="Login Page" component={Login}/>
          </Switch>
        </Router>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
  custom_visitors_list: state.reception_SheduleMeetingReducer.custom_visitors_list,
  visitors_purpose_options_list: state.reception_SheduleMeetingReducer.visitors_purpose_options_list,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // history reducer
    browserHistoryHandler: (data) => dispatch(actionCreator.browserHistoryHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
